@if (zoomLevel !== undefined) {
  <div class="ggc-zoom-level">
    {{ zoomLevel }}
  </div>
}
